import Categories from "./Categories";
import Customizations from "./Customisations/Customisations";
import SoldOut from "./SoldOut";
import Menus from "./Menus";
import Items from "../Items/Items";
import Schedules from "../Schedules";
import SoldOutOptions from "./SoldOutCustomizations";
import SoldOutCustomizations from "./CustomizationSoldOut";

export const TAB_CONFIG = [
    { id: 0, label: "Overview", component: null, isOverview: true },
    { id: 1, label: "Menus", component: Menus },
    { id: 2, label: "Categories", component: Categories, hasRefresh: true },
    { id: 3, label: "Items", component: Items },
    { id: 4, label: "Sold out", component: SoldOut },
    { id: 5, label: "Customizations", component: Customizations, hasCustomization: true },
    { id: 6, label: "Sold out customizations", component: SoldOutCustomizations },
    { id: 7, label: "Sold out options", component: SoldOutOptions },
    { id: 8, label: "Schedules", component: Schedules },
];

// API Constants
export const API_ENDPOINTS = {
  CATEGORIES: '/categories',
  ITEMS: '/items',
  CATEGORIES_PAGINATE: '/categories/paginate',
  CATEGORY_ITEMS: (categoryId) => `/categories/${categoryId}/items`,
  ITEM_DELETE: (itemId) => `/items/${itemId}`,
  CATEGORIES_SEQUENCE: '/categories/sequence-numbers',
};

// Pagination Constants
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE: 1,
};

// Query Keys for React Query
export const QUERY_KEYS = {
  CATEGORIES: 'categories',
  CATEGORY_ITEMS: 'categoryItems',
};

// Toast Messages
export const TOAST_MESSAGES = {
  SUCCESS: {
    ITEM_DELETED: {
      title: "Item deleted.",
      description: "The item was successfully deleted.",
    },
    CATEGORIES_REORDERED: {
      title: "Categories reordered.",
    },
  },
  ERROR: {
    LOAD_CATEGORIES: {
      title: "Error loading categories",
      description: "Could not load categories.",
    },
    LOAD_ITEMS: {
      title: "Error loading items",
      description: "Could not load items for this category.",
    },
    DELETE_ITEM: {
      title: "An error occurred.",
      description: "Unable to delete the item.",
    },
    UPDATE_ORDER: {
      title: "Error updating order.",
    },
  },
};

// Loading States
export const LOADING_STATES = {
  LOADING_MENU: "Loading menu...",
  LOADING_ITEMS: "Loading items...",
};

// Error States
export const ERROR_STATES = {
  FAILED_LOAD_MENU: "Failed to load menu",
  NO_CATEGORIES: "No categories found",
  CREATE_FIRST_CATEGORY: "Create your first category",
};

// Search Constants
export const SEARCH = {
  PLACEHOLDER: "Search items, categories, or customizations",
  DEBOUNCE_DELAY: 300,
};

// UI Constants
export const UI = {
  BUTTON_SIZES: { base: "sm", md: "md" },
  SPACING: { base: "2", md: "4" },
  HEADING_SIZES: { base: "lg", md: "xl" },
  FONT_SIZES: { base: "sm", md: "md" },
  INPUT_SIZES: { base: "md", md: "lg" },
};

// Animation Constants
export const ANIMATION = {
  TRANSITION_DURATION: 200,
  TRANSITION_TIMING: 'cubic-bezier(0.4, 0, 0.2, 1)',
};

// Intersection Observer Constants
export const INTERSECTION_OBSERVER = {
  THRESHOLD: 0.1,
  ROOT_MARGIN: '100px',
};